import React from "react";
import Icon from "../Icon";
import { Col, Row } from "../Grid";

const AvailableOnOsIconContainer = ({ ...props }) => {
	return (
		<Row utility={{ justify: "center" }}>
			<Col sm={12} className="available-on-os__icon-container" {...props} />
		</Row>
	);
};

AvailableOnOsIconContainer.propTypes = {
	...Col.propTypes,
};

const AvailableOnOsIcon = ({ ...props }) => {
	return <Icon className="available-on-os__icon-container__icon" {...props} />;
};

AvailableOnOsIcon.propTypes = {
	...Icon.propTypes,
};

AvailableOnOsIconContainer.Icon = AvailableOnOsIcon;

export default AvailableOnOsIconContainer;
